<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
				  <el-breadcrumb-item>个人信息</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<ul class="userbox">
				<li>
					<div class="userbox1">
						<div>头像</div>
						<img :src="user.avatar" alt="" srcset="" />
					</div>
					<p>更换头像</p>
				</li>
				<li>
					<div class="userbox1">
						<div>昵称</div>
						<span>{{user.nickname}}</span>
					</div>
					<p>编辑昵称</p>
				</li>
				<li>
					<div class="userbox1">
						<div>手机号码</div>
						<span>{{user.phone}}</span>
					</div>
					<p></p>
				</li>
				<li>
					<div class="userbox1">
						<div>邀请好友</div>
						<span>分享好友</span>
					</div>
					<p>生成邀请链接</p>
				</li>
			</ul>
			<diV class="userbox" 
			    style="margin-top:20px;">
				<div class="kpTitle">
					<h4>开票信息</h4>
					<span @click="type=!type">编辑</span>
				</div>
				<ul class="userbox" style="padding: 0;">
					<li>
						<div class="userbox1">
							<div>公司信息</div>
							<span v-if="type">{{user.company_name}}</span>
							<input v-if="!type" type="text" placeholder="请输入公司信息" v-model="valiFormData.company_name">
						</div>
						<p></p>
					</li>
					<li>
						<div class="userbox1">
							<div>公司税号</div>
							<span v-if="type">{{user.tax_id}}</span>
							<input  v-if="!type" type="text" placeholder="请输入公司税号" v-model="valiFormData.tax_id">
						</div>
						<p></p>
					</li>
					<li>
						<div class="userbox1">
							<div>邮箱信息</div>
							<span v-if="type">{{user.email}}</span>
							<input v-if="!type" type="text" placeholder="请输入内容" v-model="valiFormData.email">
						</div>
						<p></p>
					</li>
				</ul>
			</diV>
			<div class="FBxqFooter">
				<div class="FBxqFooter1" @click="tuichu">退出登录</div>
				<div class="FBxqFooter2" @click="tijiao">保存</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		personal,
		UserUpdate,
		Userlogout
	} from "@/api/api.js"
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	 //  components:{
		// rightsidebarImg  
	 //  },
	  data() {
	    return {
			radio:'1',
			type: true,
			user:'',
			valiFormData: {
				company_name: '',
				tax_id:'',
				email:"",
			},
	    }
	  },
	  created() {
	  	this.userinfo()
	  },
	  methods: {
		userinfo(){
			personal({}).then(res=>{
				this.user=res.data.data
				this.valiFormData.company_name=this.user.company_name
				this.valiFormData.tax_id=this.user.tax_id
				this.valiFormData.email=this.user.email
			})
		},
		tuichu(){
		   localStorage.removeItem("token")
		   localStorage.setItem("userType","1")
		   this.$message.error('退出登录成功')
		   setTimeout(()=>{
		   	 this.$router.push('/')
		   },1500)
		},
		tijiao(){
			if(this.type){
				return false
			}
			UserUpdate({
				...this.valiFormData
			}).then(res=>{
				if(res.data.status==200){
					 this.$message.success('提交成功')
					 this.type=true
					 this.userinfo()
					 
				}
			})
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.userbox{
		width:100%;
		background-color:#fff;
		padding:12px;
		box-sizing: border-box;
		border-radius:12px;
	}
	.userbox img{
		width: 42px;
		height:42px;
		border-radius:50%;
	}
	.userbox li{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		padding: 10px 0px;
	}
	.userbox1{
		display:flex;
		align-items: center;
	}
	.userbox1 div{
		width: 160px;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.userbox1 span{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}
	.userbox1 input{
		width:300px;
		height:30px;
		border-radius: 6px;
		border:1px solid #666666;
		outline:none;
		padding-left:5px;
	}
	.userbox li>p{
		font-weight: 500;
		font-size: 16px;
		color: #4297FF;
		cursor:pointer;
	}
	
	.FBxqFooter{
		width:100%;
		padding:30px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.FBxqFooter1{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #1E3A8A;
		cursor:pointer;
	}
	.FBxqFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px ;
		margin-left:32px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
	.kpTitle{
		width:100%;
		display:flex;
		align-items:center;
		justify-content:space-between;
	}
	.kpTitle h4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.kpTitle span{
		font-weight: 500;
		font-size: 16px;
		color: #4297FF;
		cursor:pointer;
	}
</style>